import styled from 'styled-components'

export const ActionsContainer = styled.div`
  height: 36px;
`
